import { createActions, createReducer } from 'reduxsauce'

import ResponsaveisObrasService from '../../servicos/ResponsaveisObrasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaResponsaveisInicio: [],
    buscaResponsaveisSucesso: ['responsaveis'],
    buscaResponsaveisErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaResponsaveis = filtro => {
    return dispatch => {
        dispatch(Creators.buscaResponsaveisInicio())
        let serv = new ResponsaveisObrasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaResponsaveisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaResponsaveisErro(error)))
    }
}

const buscaResponsaveisInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaResponsaveisErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaResponsaveisSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.responsaveis, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RESPONSAVEIS_INICIO]: buscaResponsaveisInicio,
    [Types.BUSCA_RESPONSAVEIS_ERRO]: buscaResponsaveisErro,
    [Types.BUSCA_RESPONSAVEIS_SUCESSO]: buscaResponsaveisSucesso,
})
